import { Badge } from "@devhop/ui";

type ReportDetailToolbarProps = {
  reportId: string;
  status: string;
  statusLabel: string;
};

export function ReportDetailToolbar({
  reportId,
  status,
  statusLabel,
}: ReportDetailToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">
          ລາຍລະອຽດ & ການແກ້ໄຂ
        </h2>
        <p className="text-muted-foreground text-sm">ລະຫັດລາຍງານ: {reportId}</p>
      </div>
      <Badge
        variant={status === "reviewing" ? "secondary" : "outline"}
        className={
          status === "reviewing"
            ? "bg-amber-500/20 text-amber-600 dark:text-amber-400"
            : ""
        }
      >
        {statusLabel}
      </Badge>
    </div>
  );
}
